import React from "react";
import { createRoot } from "react-dom/client";

// relative imports
import Router from "./routes";

createRoot(document.getElementById("root")).render(<Router />);
